import getFaqArticles from './getFaqArticles'
import getFaqCategories from './getFaqCategories'

const faq = {
  getFaqArticles,
  getFaqCategories
}

export default faq
